export default "__VITE_ASSET__BoZw9uDk__"